<div [hidden]="isHidden" class="text-center">
  <i class="ft-aperture font-large-1 fa fa-spin align-middle text-primary" *ngIf="iconShow"></i>
  <p *ngIf="text">{{text}}</p>
</div>
